/* ================================================== */
/* ACCESSIBILITY → Read more
/* ================================================== */

$(document).ready(function() {
	$('.read-more').click(function() {
		$(this).attr('aria-expanded', function (i, attr) {
    		return attr == 'true' ? 'false' : 'true'
		});
		$(this).next().attr('aria-hidden', function (i, attr) {
			return attr == 'true' ? 'false' : 'true'
		});
	});
});